import { useState } from "react";

import { OlgaEnvironmentsAPI } from "../../../providers/OlgaEnvironmentsAPI";
import styles from "../../../styles/mensageria.module.scss";
import { Button } from "../../components/Button";
import { Checkbox } from "../../components/Checkbox";
import { Drawer } from "../../components/Drawer";
import { Hairline } from "../../components/Hairline";
import { Input } from "../../components/Input";
import { ForEach, If } from "../../components/control-statements";
import { Icon } from "../../components/core/Icon";
import { Environment } from "../../core/Environment";

const MESSENGER_PROVIDERS = {
  INFOBIP: {
    name: "InfoBip",
    alias: "infobip",
    active: false,
    fields: {
      apiKey: "Chave da API",
      baseUrl: "URL Base",
    },
  },
  ONESIGNAL: {
    name: "OneSignal",
    alias: "onesignal",
    active: false,
    fields: {
      apiKey: "Chave da API",
    },
  },
};

export const ProvidersConfigurationDrawer = ({
  onClose,
  messenger,
  setMessenger,
  setConfiguredMessaging,
}) => {
  const [loading, setLoading] = useState(false);
  const [configureSuccess, setConfigureSuccess] = useState(false);

  const validProvidersConfigurations = () => {
    if (!messenger) {
      return false;
    }

    const anyProviderActive = Object.values(messenger).find(
      (provider) => provider.active === true
    );
    if (!anyProviderActive) {
      return false;
    }

    const validations = Object.values(MESSENGER_PROVIDERS).map((provider) => {
      const configurations = messenger[provider.alias];

      if (!configurations) {
        return false;
      }

      if (!configurations.active) {
        return true;
      }

      const providerFields = Object.keys(provider.fields);
      const invalidFields = providerFields.find((field) => {
        return !configurations[field] || configurations[field]?.length <= 3;
      });

      return !invalidFields;
    });

    return !validations.includes(false);
  };

  const onSaveServices = async () => {
    if (!messenger) {
      return false;
    }

    setLoading(true);
    const saveReq = await OlgaEnvironmentsAPI.putConfigurations({
      services: messenger,
    });

    if (saveReq.getErrors([]).length === 0) {
      await Environment.installConfigurations();
      setConfigureSuccess(true);
      setConfiguredMessaging(true);
    }
    setLoading(false);
  };

  return (
    <Drawer
      visible={true}
      onClose={() => onClose()}
      title={configureSuccess ? "Sucesso" : "Configurar mensageria"}
      subtitle={configureSuccess ? "Mensageria configurada." : null}
    >
      <If cond={!configureSuccess}>
        <ForEach
          items={Object.values(MESSENGER_PROVIDERS)}
          render={(provider, pIdx) => (
            <>
              <Checkbox
                family="provider"
                key={`${pIdx}_checkbox`}
                className="mb-10"
                value={provider.alias}
                checked={messenger?.[provider.alias]?.active}
                onChange={() =>
                  setMessenger({
                    ...messenger,
                    [provider.alias]: {
                      ...messenger?.[provider.alias],
                      active: !messenger?.[provider.alias]?.active,
                    },
                  })
                }
              >
                {provider.name}
              </Checkbox>

              <ForEach
                items={Object.keys(provider?.fields || {})}
                render={(field, fIdx) => (
                  <Input
                    key={`${pIdx}_${fIdx}_input`}
                    placeholder={provider?.fields[field]}
                    className="mb-10"
                    onChange={(e) =>
                      setMessenger({
                        ...messenger,
                        [provider.alias]: {
                          ...messenger?.[provider.alias],
                          [field]: e.target.value,
                        },
                      })
                    }
                    value={messenger?.[provider.alias]?.[field]}
                  />
                )}
              />

              {pIdx !== Object.values(MESSENGER_PROVIDERS).length - 1 && (
                <Hairline key={`${pIdx}_baseline`} className="mt-20 mb-20" />
              )}
            </>
          )}
        />

        <div className={styles.footer}>
          <If cond={!configureSuccess}>
            <Button
              className="w-100"
              design="primary"
              disabled={!validProvidersConfigurations()}
              onClick={() => onSaveServices()}
              loading={loading}
            >
              Salvar
            </Button>
          </If>
        </div>
      </If>

      <If cond={configureSuccess}>
        <div className={styles.successContainer}>
          <div className={styles.success}>
            <Icon name="check" />
          </div>
        </div>

        <div className={styles.footer}>
          <Button className="w-100" onClick={() => onClose && onClose()}>
            Fechar
          </Button>
        </div>
      </If>
    </Drawer>
  );
};
